import { GeoLocation } from '../appTypings';
import { Label } from '@yleisradio/areena-types';

export const getRegion = (labels: Label[]): string => {
  if (!labels) return '';
  const { raw: region } = labels.find(label => label.type === 'region') || {};
  return region?.toString() || '';
};

export const getIsGeoBlocked = (
  geoLocation: GeoLocation,
  region?: string
): boolean => {
  return geoLocation !== GeoLocation.Finland && region === GeoLocation.Finland;
};
